/* VeeVee · Make it a gift — product page block */
class VVGiftComponent extends HTMLElement {
  connectedCallback() {
    this.root = this.querySelector('.vv-gift');
    if (!this.root) return;
    this.box = this.root.querySelector('[ref="box"]');
    this.toggle = this.root.querySelector('[ref="toggle"]');
    this.panel = this.root.querySelector('[ref="panel"]');
    this.propGift = this.root.querySelector('[ref="propGift"]');
    this.propRibbon = this.root.querySelector('[ref="propRibbon"]');
    this.note = this.root.querySelector('[ref="note"]');
    this.count = this.root.querySelector('[ref="count"]');
    this.desc = this.root.querySelector('[ref="desc"]');
    this.pills = Array.from(this.root.querySelectorAll('.vv-gift__pill'));
    this.key = 'vv-gift:' + (this.root.dataset.productId || '');

    this.toggle.addEventListener('change', () => this.apply({ on: this.toggle.checked }));
    this.pills.forEach((p) => p.addEventListener('click', () => this.apply({ ribbon: p.dataset.ribbon })));
    this.note.addEventListener('input', () => this.apply({ note: this.note.value }));
    // Don't send an empty "Gift note" property: disable the field for the duration of the submit
    const formEl = document.getElementById(this.root.dataset.formId || '');
    if (formEl) {
      formEl.addEventListener('submit', () => {
        if (this.state.on && this.note.value.trim() === '') {
          this.note.disabled = true;
          setTimeout(() => { this.note.disabled = !this.state.on; }, 0);
        }
      }, true);
    }

    // Restore state (survives variant changes, which re-render the section)
    this.state = { on: false, ribbon: 'Neutral', note: '' };
    try {
      const saved = JSON.parse(sessionStorage.getItem(this.key) || 'null');
      if (saved) this.state = { ...this.state, ...saved };
    } catch (e) {}
    this.render();

    this.onVariantUpdate = () => requestAnimationFrame(() => this.render());
    document.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this.onVariantUpdate);
  }

  apply(patch) {
    this.state = { ...this.state, ...patch };
    try { sessionStorage.setItem(this.key, JSON.stringify(this.state)); } catch (e) {}
    this.render();
  }

  render() {
    const { on, ribbon, note } = this.state;
    this.toggle.checked = on;
    this.panel.hidden = !on;
    this.box.classList.toggle('is-on', on);
    this.propGift.disabled = !on;
    this.propRibbon.disabled = !on;
    this.propRibbon.value = ribbon;
    this.note.disabled = !on;
    if (this.note.value !== note) this.note.value = note;
    const max = this.note.maxLength > 0 ? this.note.maxLength : 200;
    this.count.textContent = `${note.length} / ${max}`;
    this.pills.forEach((p) => {
      const sel = p.dataset.ribbon === ribbon;
      p.classList.toggle('is-selected', sel);
      p.setAttribute('aria-checked', sel ? 'true' : 'false');
      if (sel) this.desc.textContent = p.dataset.desc || '';
    });
    // Flag the product form so express checkout is hidden while a gift is selected
    const form = document.getElementById(this.root.dataset.formId || '');
    const pfc = form ? form.closest('product-form-component') : null;
    if (pfc) pfc.dataset.vvGift = on ? 'on' : 'off';
  }
}

if (!customElements.get('vv-gift-component')) {
  customElements.define('vv-gift-component', VVGiftComponent);
}

// After a successful add to cart, reset the block so the next add starts clean
document.addEventListener('cart:update', (e) => {
  if (e.detail?.data?.source !== 'product-form-component' || e.detail?.data?.didError) return;
  document.querySelectorAll('vv-gift-component').forEach((el) => {
    if (el.state?.on) el.apply({ on: false, note: '' });
  });
});
